import { render } from "./PublicUploadHandler.vue?vue&type=template&id=d521d564&scoped=true&ts=true"
import script from "./PublicUploadHandler.vue?vue&type=script&lang=ts"
export * from "./PublicUploadHandler.vue?vue&type=script&lang=ts"

import "./PublicUploadHandler.vue?vue&type=style&index=0&id=d521d564&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d521d564"]])

export default __exports__